/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiTaxDeclarationInitializeDocumentPost$Json$Params {
  
    /**
     * Multipart form data. The tax year plus the prior-year declaration document to prefill from.
     */
    body: {

/**
 * Tax year the new declaration is created for.
 */
'year': number;

/**
 * The prior-year tax-declaration document. The AI pipeline extracts and prefills the new declaration from it.
 */
'file': Blob;
}
}

export function apiTaxDeclarationInitializeDocumentPost$Json(http: HttpClient, rootUrl: string, params: ApiTaxDeclarationInitializeDocumentPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiTaxDeclarationInitializeDocumentPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiTaxDeclarationInitializeDocumentPost$Json.PATH = '/api/TaxDeclaration/initialize-document';
